"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultConfiguration = void 0;
exports.defaultConfiguration = {
  clientId: '',
  developerKey: '',
  viewId: 'DOCS',
  callbackFunction: function callbackFunction() {
    return null;
  }
};